import { Typography } from "@lyfegen-platform/react-common";
import { Box, Container, Divider, Link, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next/";
import { useMapThemeClasses } from "../hooks/use-map-theme-styles";
import LyfegenLogo from "./icons/LyfegenLogo";

export default function NoModule() {
	const { container } = useMapThemeClasses();
	const { t } = useTranslation();
	const { palette } = useTheme();

	return (
		<Container component="main" maxWidth="xs" classes={{ root: container }}>
			<Box display="flex" justifyContent="center" mb={3}>
				<LyfegenLogo vertical />
			</Box>
			<Box marginLeft={-3} marginRight={-3}>
				<Divider />
			</Box>
			<Typography
				style={{
					marginBottom: "110px",
					marginLeft: "-24px",
					marginRight: "-24px",
					backgroundColor: palette.background.default,
					paddingTop: "10px",
					paddingBottom: "10px",
				}}
				align="center"
				type={"regular"}
			>
				{t("np-modules")}{" "}
				<Link color="primary" href="mailto:lyfegen@support.com">
					lyfegen@support.com
				</Link>{" "}
				{t("np-modules-sec-part")}
			</Typography>
		</Container>
	);
}
